import React from 'react';
import { AssistanceFormProvider } from '../../common/contexts/AssistanceForm/AssistanceForm.provider';
import { AppContainer, AppWrapper } from '../../common/styles/CommonStyle';
import { Header } from '../../components/Header/Header';
import { ProgressBar } from '../../components/ProgressBar';
import { Outlet } from 'react-router-dom';

export const RootLayout = (): JSX.Element => (
  <AssistanceFormProvider>
    <AppContainer>
      <Header />
      <ProgressBar />
      <AppWrapper>
        <Outlet />
      </AppWrapper>
    </AppContainer>
  </AssistanceFormProvider>
);
